export default __webpack_public_path__ + "static/media/favicon.d1b20962.ico";